import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, type Qualified} from '@packages/systems/wfdl-Qualified';

import {type ExpressionElement} from '@packages/systems/wfdl-ast';

export const boundaryElementType: Qualified<Component.ComponentName> = qualify(
  Plugins.name('Commerce'),
  Component.name('CommerceCartWrapper')
);

export const createBindingContextBoundary = (
  element: ExpressionElement
): Readonly<{
  boundaryType: 'startAfter';
  boundaryElementId: string;
  boundaryContextVariant: 'Entity';
}> => {
  return {
    boundaryType: 'startAfter',
    boundaryElementId: element.id,
    boundaryContextVariant: 'Entity',
  };
};
